<template>
  <div class="container-fluid mt--12">
    <actions-declaracao-inss/>
    <div class="row">
      <div class="col-sm-12 col-lg-12">
        <cadastro-declaracao-inss/>
      </div>
    </div>
  </div>
</template>

<script>
import LicencaPrevidenciariaCadastroDetalhado from "./LicencaPrevidenciariaCadastroDetalhado";
import LicencaPrevidenciariaActions from "./LicencaPrevidenciariaActions";
export default {
  name: "LicencaPrevidenciariaContainerCadastro",
  components: {
    "cadastro-declaracao-inss": LicencaPrevidenciariaCadastroDetalhado,
    "actions-declaracao-inss": LicencaPrevidenciariaActions
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/licencaPrevidenciaria/LicencaPrevidenciariaContainerCadastro.vue